import { IconButton } from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import AppButton from "../../../../AppComponents/AppButton";
import {
  AppForm,
  AppFormRadioField,
  AppSubmitButton,
} from "../../../../AppComponents/Forms";
import { theme } from "../../../../Customization/Theme";
import { AppMaterialIcons } from "../../../appComponents/Icons";

import { useAppDispatch, useAppSelector } from "../../../../Store";
import { LiveChatData } from "../../../../Store/Slices/socket/liveChat/chat.selectors";
import AppReactSelectField from "../../../appComponents/UtilsComponents/AppFormReactSelect";

import {
  HocBackdropLoader,
  HocBackdropLoaderProps,
} from "../../../../HOC/HocBackdropLoader";
import { removeAllMessages } from "../../../../Store/Slices/socket/AllMessagesSlice";
import {
  TEMP_ACTIVE_FILTERS,
  setChatSessionActiveFilters,
} from "../../../../Store/Slices/socket/liveChat/chat.slice";
import {
  chatFilterConversationStatusOptions,
  chatFilterOrderByOptions,
  chatFilterStatusOptions,
} from "./constants";
import { useAuthStore } from "../../../../Store/Slices/AuthSlice";
import { queryClient } from "../../../../Utils/tanstack-query";

interface Props extends HocBackdropLoaderProps {
  setIsFilterScreenOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFilterScreenOpen: boolean;
}

const ChatFiltersScreen: React.FC<Props> = ({
  setIsFilterScreenOpen,
  isFilterScreenOpen,
  setLoading,
}) => {
  const dispatch = useAppDispatch();
  const {
    chatSessionActiveFilter,
  } = useAppSelector(LiveChatData);
  const { userConfig } = useAppSelector(useAuthStore);

  // const queryKey1 = ["conversations", "channels", "listing"];
  const queryKey2 = ["conversations", "labels", "listing"];
  const queryKey6 = ["conversations", "online-users", "listing"];
  // const allChannelsData: any = queryClient.getQueryData(queryKey1) ?? [];
  const allLabelsData: any = queryClient.getQueryData(queryKey2) ?? [];
  const allAgentsData: any = queryClient.getQueryData(queryKey6) ?? [];
  const [buttonClicked, setButtonClicked] = useState(false);


  const handleSubmitFn = (values: any, submitProps: any) => {
    submitProps?.setSubmitting(false);
    const isAllTabsAvailable =
      userConfig?.payload?.allowed_permissions?.can_view_all_chats_tab === true;
    // let tempValues: any = { ...values, conversation: isAllTabsAvailable ? "all" : "mine", search: "" };
    let tempValues: any = { ...values, search: "" };

    dispatch(removeAllMessages({}));

    dispatch(setChatSessionActiveFilters(tempValues));
    setIsFilterScreenOpen(false);

  };

  const handleResetBtn = () => {
    dispatch(removeAllMessages({}));
    const isAllTabsAvailable =
      userConfig?.payload?.allowed_permissions?.can_view_all_chats_tab === true;
    dispatch(
      setChatSessionActiveFilters({
        ...TEMP_ACTIVE_FILTERS,
        chat_status: [],
        conversation: isAllTabsAvailable ? "all" : "mine",
      })
    );
    setIsFilterScreenOpen(false);

  };

  return (
    <StyledChatFilterScreenWrap>
      <AppForm
        initialValues={chatSessionActiveFilter}
        onSubmit={(values: any, submitProps: any) => {
          setButtonClicked(true);
          handleSubmitFn(values, submitProps);
        }}
        // validationSchema={LiveChatFilterSchema}
        validateOnChange={false}
      >
        <div className="fixed-top" style={{ paddingLeft: "5%" }}>
          Filters{" "}
          <IconButton
            className="filter"
            onClick={() => setIsFilterScreenOpen(false)}
          >
            <AppMaterialIcons iconName="close" style={{ fontSize: "20px" }} />
          </IconButton>
        </div>
        <><style>
          {`
      .MuiInputLabel-root,
      .MuiFormLabel-root,
      label {
        color: #101010 !important;
        font-weight: 500 !important;
      }
      .MuiInputLabel-root.Mui-focused,
      .MuiFormLabel-root.Mui-focused {
        color: #101010 !important;
        
      }
    `}
        </style>
        <div className="scrollable-content">
          <AppReactSelectField
            name="chat_status"
            options={chatFilterStatusOptions ?? []}
            label="Chat Status"
            labelId="inbox-chat-status"
            valueKey={"value"}
            isMulti={true}
            styles={{
              option: (provided: any, state: { isFocused: any; isSelected: any; }) => ({
                ...provided,
                backgroundColor: state.isFocused || state.isSelected ? 'rgba(7, 94, 84, 0.1)' : 'white',
                color: state.isSelected ? 'white' : '#101010', 
                '&:hover': {
                  backgroundColor: 'rgba(7, 94, 84, 0.1)', 
                  color: 'white', 
                },
              }),
            }}

            />
            {
              chatSessionActiveFilter?.conversation !== "all" && chatSessionActiveFilter?.conversation !== "mine" ? null :
                <AppReactSelectField
                  name="conversation_status"
                  options={
                    chatSessionActiveFilter?.conversation === "mine" 
                      ? chatFilterConversationStatusOptions.filter(option => option.value === "unattended")
                      : chatFilterConversationStatusOptions ?? []
                  }
                  labelId="inbox-conversation-status"
                  label="Conversation"
                  valueKey={"value"}
                  isMulti={true}
                  hideSelectedOptions={true}
                  styles={{
                    option: (provided: any, state: { isFocused: any; isSelected: any; }) => ({
                      ...provided,
                      backgroundColor: state.isFocused || state.isSelected ? 'rgba(7, 94, 84, 0.1)' : 'white',
                      color: state.isSelected ? 'white' : '#101010',
                      '&:hover': {
                        backgroundColor: 'rgba(7, 94, 84, 0.1)',
                        color: 'white',
                      },
                    }),
                  }}
                />
            }
          <AppReactSelectField
            name="labels"
            options={allLabelsData.map((res: any) => ({
              ...res,
              value: res.id ?? res.value,
            }))  ?? []}
            label="Labels"
            valueKey={"value"}
            isMulti={true}
            styles={{
              option: (provided: any, state: { isFocused: any; isSelected: any; }) => ({
                ...provided,
                backgroundColor: state.isFocused || state.isSelected ? 'rgba(7, 94, 84, 0.1)' : 'white',
                color: state.isSelected ? 'white' : '#101010', 
                '&:hover': {
                  backgroundColor: 'rgba(7, 94, 84, 0.1)', 
                  color: 'white', 
                },
              }),
            }}          />
          {/* 
          <AppReactSelectField
            name="channels"
            options={allChannelsData ?? []}
            label="Channels"
            labelId="inbox-channels"
            valueKey={"value"}
            isMulti={true}
          />
          */}
          {userConfig?.payload?.role?.name === "admin" && chatSessionActiveFilter?.conversation === "all" ? (
            <AppReactSelectField
              name="agents"
              options={allAgentsData.map((res: any) => ({
              ...res,
              value: res.id ?? res.value,
            })) ?? []}
              label="Agents"
              valueKey={"value"}
              isMulti={true}
              styles={{
                option: (provided: any, state: { isFocused: any; isSelected: any; }) => ({
                  ...provided,
                  backgroundColor: state.isFocused || state.isSelected ? 'rgba(7, 94, 84, 0.1)' : 'white',
                  color: state.isSelected ? 'white' : '#101010', 
                  '&:hover': {
                    backgroundColor: 'rgba(7, 94, 84, 0.1)', 
                    color: 'white', 
                  },
                }),
              }}            />
          ) : null}

            <AppFormRadioField
              name="order"
              Options={chatFilterOrderByOptions ?? []}
              label="Sort By"
            />
          </div>
        </>
        <div
          className="fixed-bottom"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "16px",
            paddingBottom: "0.7rem",
            paddingRight: "1rem",
          }}
        >
          <AppButton variant="danger" id="inbox-reset" onClick={handleResetBtn}>
            Reset
          </AppButton>{" "}
          <AppSubmitButton id="inbox-apply-filters" title={"Apply Filters"}  disabled={buttonClicked} />
        </div>

      </AppForm>
    </StyledChatFilterScreenWrap>
  );
};

export default HocBackdropLoader(ChatFiltersScreen);

const StyledChatFilterScreenWrap = styled.div`
  && {
    height: 100%;
    width: 100%;
    padding: 0rem 0rem;
    display: flex;
    flex-direction: column;

    .fixed-top,
    .fixed-bottom {
      height: 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 1rem;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
      font-size: 1rem;
    }

    .scrollable-content {
      flex: 1;
      height: 100%;
      min-height: calc(100vh - 200px);
      max-height: 250px;
      overflow: auto;
      padding: 0.5rem 1rem;
    }

    .filter {
      width: 28px;
      height: 28px;
      & .MuiSvgIcon-root {
        color: ${theme.palette.default.darkGrey};
        font-size: 1.4rem;
      }
    }
  }
`;
